import React, { useEffect, useState } from 'react';
import { Tree } from 'antd';
import style from './articleTree.module.css';
import collection from './images/collection.png';
import collected from "./images/collected.png";

const { TreeNode } = Tree;

const ArticleTree = (props) => {
  const { data = [], selectHandler, cancelCollect } = props;
  const [expandedKeys, setExpandedKeys] = useState([]);
  const [selectedKeys, setSelectedKeys] = useState([]);

  useEffect(() => {
    if (data.length > 0) {
      // 假设你想要展开每个顶级节点
      const newExpandedKeys = data.map(item => item.dateStr);
      setExpandedKeys(newExpandedKeys);

      // 设置选中的键
      const newSelectedKeys = [`${data[0]?.articleList[0].id}`];
      setSelectedKeys(newSelectedKeys);
    }
  }, [data]);

  useEffect(() => {
    selectHandler(selectedKeys);
  }, [selectedKeys]);
  return (
    <Tree
      // showIcon
      expandedKeys={expandedKeys}
      selectedKeys={selectedKeys}
      onSelect={(keys, e) => {
        setSelectedKeys(keys);
      }}
      style={{ marginTop: '15px' }}
    >
      {data.map((item, key) => {
        return (
          <TreeNode title={item.dateStr} key={item.dateStr}>
            {item.articleList.map((art, index) => {
              return (
                <TreeNode
                  // icon={
                  //   <img
                  //     src={art.positionContentVo.collect ? collected : collection}
                  //     onClick={(e) => {
                  //       e.stopPropagation();
                  //       cancelCollect({
                  //         contentId: art.positionContentVo.contentId,
                  //         collectFolderId: art.collectFolderId,
                  //         collectFolderName: art.collectFolderName
                  //       });
                  //     }}
                  //     style={{ width: '20px', height: '20px', transform: 'translateY(-2px)' }}
                  //   />
                  // }
                  title={art.positionContentVo.title}
                  key={art.id}
                  className={style.treeNode}
                />
              );
            })}
          </TreeNode>
        );
      })}
    </Tree>
  );
};

export default ArticleTree;